var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.8 15.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Success") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9,1.5c3.53,0,6.4,2.87,6.4,6.4s-2.87,6.4-6.4,6.4s-6.4-2.86-6.4-6.4S4.37,1.5,7.9,1.5z M7.9,0 C3.54,0,0,3.54,0,7.9s3.54,7.9,7.9,7.9s7.9-3.54,7.9-7.9S12.27,0,7.9,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1801,11.66c-0.18,0-0.37-0.07-0.51-0.2l-2.39-2.24c-0.3-0.28-0.32-0.76-0.03-1.06 c0.28-0.3,0.76-0.32,1.06-0.03l1.88,1.76l5.1-4.78c0.3-0.28,0.78-0.27,1.06,0.03c0.28,0.3,0.27,0.78-0.03,1.06l-5.61,5.26 c-0.14,0.14-0.33,0.2-0.51,0.2H6.1801z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.0f58790e8899daa1278bd912425cc835.svg";
export { ForwardRef as ReactComponent };